import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import img1 from '../../assets/img/Add a heading (11).png';
import logoimg from '../../assets/logo/Add a heading (12).png';
import '../Styles/RegisterLogin.css';

const Register = () => {
  const [captcha, setCaptcha] = useState('');
  const [userCaptcha, setUserCaptcha] = useState('');
  // const [isCaptchaValid] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    licenceNumber: '',
    gstNumber: '',
    shopName: '',
    shopAddress: '',
    pharmacistId: '',
    hospitalId: '',
  });
  const [selectedRole, setSelectedRole] = useState('pharmacist');
  const [showAlert, setShowAlert] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const randomText = Math.random().toString(36).substring(2, 8).toUpperCase();
    setCaptcha(randomText);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Password match validation
    if (formData.password !== formData.confirmPassword) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    // Captcha validation
    if (userCaptcha !== captcha) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
      return;
    }

    // Dummy success behavior
    alert('Registration successful!');
    navigate('/');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleRegisterClick = () => {
    navigate('/');
  };

  const handleRoleChange = (e) => {
    setSelectedRole(e.target.value);
    setFormData({
      ...formData,
      licenceNumber: '',
      gstNumber: '',
      shopName: '',
      shopAddress: '',
      pharmacistId: '',
      hospitalId: '',
    });
  };

  return (
    <div className="login-form-container">
      <div className="left-side">
        <div className="image-container">
          <img src={img1} alt="background" className="animated-image" />
        </div>
        <img src={logoimg} alt="" className="logo" />
        <div className="register-text">
          Already have an account?
          <button className="register-btn" onClick={handleRegisterClick}>Login here!</button>
        </div>
      </div>

      {showAlert && (
        <div className="alert">
          {formData.password !== formData.confirmPassword ? 'Password does not match! Please Try again' : 'Captcha Incorrect! Try Again.'}
        </div>
      )}

      <div className="right-side">
        <form onSubmit={handleSubmit} className="login-form">
          <h2>Register</h2>

          <div className="input-field">
            <label>Select Role</label>
            <select name="role" value={selectedRole} onChange={handleRoleChange} required>
              <option value="distributor">Distributor</option>
              <option value="pharmacist">Pharmacist</option>
            </select>
          </div>

          <div className="input-field">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {selectedRole === 'distributor' && (
            <>
              <div className="input-field">
                <label>Licence Number</label>
                <input
                  type="text"
                  name="licenceNumber"
                  value={formData.licenceNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-field">
                <label>GST Number</label>
                <input
                  type="text"
                  name="gstNumber"
                  value={formData.gstNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-field">
                <label>Shop Name</label>
                <input
                  type="text"
                  name="shopName"
                  value={formData.shopName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-field">
                <label>Shop Address</label>
                <input
                  type="text"
                  name="shopAddress"
                  value={formData.shopAddress}
                  onChange={handleChange}
                  required
                />
              </div>
            </>
          )}

          {selectedRole === 'pharmacist' && (
            <>
              <div className="input-field">
                <label>Pharmacist ID</label>
                <input
                  type="text"
                  name="pharmacistId"
                  value={formData.pharmacistId}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-field">
                <label>Hospital ID</label>
                <input
                  type="text"
                  name="hospitalId"
                  value={formData.hospitalId}
                  onChange={handleChange}
                  required
                />
              </div>
            </>
          )}

          <div className="input-field password-container">
            <label>Password</label>
            <input
              type={isPasswordVisible ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <span className="eye-icon" onClick={togglePasswordVisibility}>
              {isPasswordVisible ? '🙈' : '👁️'}
            </span>
          </div>

          <div className="input-field password-container">
            <label>Confirm Password</label>
            <input
              type={isConfirmPasswordVisible ? 'text' : 'password'}
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <span className="eye-icon" onClick={toggleConfirmPasswordVisibility}>
              {isConfirmPasswordVisible ? '🙈' : '👁️'}
            </span>
          </div>

          <div className="captcha-field">
            <label>Captcha</label>
            <div className="captcha-container">
              <span>{captcha}</span>
            </div>
            <input
              type="text"
              value={userCaptcha}
              onChange={(e) => setUserCaptcha(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-btn">Register</button>
        </form>
      </div>
    </div>
  );
};

export default Register;
